import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import s from './Kebab.module.css';
import { Icon } from '../Icon';
// Must stay in sync with the close animation duration in Kebab.module.css
// (.menu[data-state='closed']). Matches the Sidebar service-menu's 180ms.
const CLOSE_MS = 180;
export function Kebab({ items, label = 'Open menu' }) {
    // Two-state pattern mirroring Sidebar's service-switcher menu (see
    // Sidebar.tsx `serviceMenuOpen` / `serviceMenuMounted`):
    //   `open` drives the in/out keyframe via data-state
    //   `mounted` keeps the element in the DOM long enough for the exit
    //   keyframe to play before we strip it.
    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false);
    const ref = useRef(null);
    // Mount when opening; schedule unmount after the close keyframe finishes.
    useEffect(() => {
        if (open) {
            setMounted(true);
            return;
        }
        if (!mounted)
            return;
        const t = window.setTimeout(() => setMounted(false), CLOSE_MS);
        return () => window.clearTimeout(t);
    }, [open, mounted]);
    useEffect(() => {
        if (!open)
            return;
        const onDoc = (e) => {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        };
        const onKey = (e) => {
            if (e.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDoc);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    return (_jsxs("div", { className: s.wrap, ref: ref, children: [_jsx("button", { type: "button", className: s.btn, "data-open": open ? 'true' : undefined, "aria-label": label, "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpen((v) => !v), children: _jsx(Icon, { name: "more", size: 16 }) }), mounted && (_jsx("div", { role: "menu", className: s.menu, "data-state": open ? 'open' : 'closed', children: items.map((item, i) => (_jsxs("button", { role: "menuitem", type: "button", className: [s.item, item.danger && s.danger].filter(Boolean).join(' '), onClick: () => {
                        setOpen(false);
                        item.onClick();
                    }, children: [item.icon && _jsx(Icon, { name: item.icon, size: 14, className: s.itemIcon }), _jsx("span", { children: item.label })] }, i))) }))] }));
}
